module.exports = __webpack_public_path__ + "static/img/remove.596d7722.svg";